import React, { useEffect, useState } from "react"
import _ from "lodash"
import {
  collection,
  getDocs,
  query,
  where,
  setDoc,
  doc,
  addDoc,
} from "firebase/firestore"
import { db, storage } from "../Firebase/Firebase-config"

const ContactMe = () => {
  const dbCollectionRef = collection(db, "contact-us")
  const [isLoader, setIsLoader] = useState(false)
  const [values, setValues] = useState({
    delete: false,
    email: "",
    message: "",
    name: "",
    fname: "",
    lname: "",
  })

  const create = async () => {
    setIsLoader(true)
    if (values.name && values.email && values.message) {
      await addDoc(dbCollectionRef, { ...values })
      setIsLoader(false)
      console.log("upload")
      setValues((fname) => ({
        ...fname,
        fname: "",
      }))
      setValues((lname) => ({
        ...lname,
        lname: "",
      }))
      setValues((email) => ({
        ...email,
        email: "",
      }))
      setValues((message) => ({
        ...message,
        message: "",
      }))
    } else {
      alert("fill all details")
    }
  }

  useEffect(() => {
    setValues((name) => ({
      ...name,
      name: values.fname + " " + values.lname,
    }))
  }, [values.fname, values.lname])

  return (
    <div className="flex flex-col w-full flex- 1 items-center pt-20 px-3 h-[680px] bg-primary">
      <div className="lg:w-[814px] md:h-[480px] h-[580px] flex flex-col justify-between">
        <h1 className="md:text-3xl text-2xl text-center font-medium">
          Let me know what's on your mind
        </h1>
        {/* get info */}
        <div className="md:pt-12 flex flex-col justify-between md:h-[362px] space-y-4 md:space-y-0">
          {/* 1 col */}
          <div className="flex md:flex-row flex-col justify-between space-y-5 md:space-y-0 md:space-x-9">
            <div className="flex flex-col space-y-7 flex-1">
              <span>First Name</span>
              <input
                type="text"
                className="bg-transparent border-b-2 border-black px-2 pb-1 pt-4  focus:outline-none"
                value={values.fname}
                autoComplete="off"
                onChange={(e) => {
                  setValues((fname) => ({
                    ...fname,
                    fname: e.target.value,
                  }))
                }}
              />
            </div>
            <div className="flex flex-col space-y-7 flex-1">
              <span>Last Name</span>
              <input
                type="text"
                className="bg-transparent border-b-2 border-black px-2 pb-1 pt-4  focus:outline-none"
                value={values.lname}
                autoComplete="off"
                onChange={(e) => {
                  setValues((lname) => ({
                    ...lname,
                    lname: e.target.value,
                  }))
                }}
              />
            </div>
          </div>
          {/* 2 col */}
          <div className="flex md:flex-row flex-col justify-between space-y-4 md:space-y-0 md:space-x-9">
            <div className="flex flex-col space-y-7 flex-1">
              <span>Email</span>
              <input
                type="email"
                className="bg-transparent border-b-2 border-black px-2 pb-1 pt-4  focus:outline-none"
                value={values.email}
                autoComplete="off"
                onChange={(e) => {
                  setValues((email) => ({
                    ...email,
                    email: e.target.value,
                  }))
                }}
              />
            </div>
            <div className="flex flex-col space-y-1 flex-1">
              <span>Leave us a message....</span>
              <textarea
                className="bg-transparent border-b-2 border-black p-2  focus:outline-none"
                value={values.message}
                onChange={(e) => {
                  setValues((message) => ({
                    ...message,
                    message: e.target.value,
                  }))
                }}
              />
            </div>
          </div>
          {/* submit button */}
          <div className="w-full md:mt-0 flex flex-col justify-center items-center">
            <button
              className="bg-white flex px-9 py-3 w-fit font-medium text- white"
              onClick={() => {
                create()
              }}
            >
              <span>{!isLoader ? "Submit" : "Send"}</span>
            </button>
            <span className="md:mt-5 w-full text-center">
              Thanks for submitting!
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactMe
